const ru = {
  durationTxt: 'Полная установка с нуля',
  costTxt: 'Стоимость установки',
  niceToHaveTxt: 'Желательно',
  mustHaveTxt: 'Обязательно',
  sectionTitle: 'Пирамида потребностей компании',
  learnMoreTxt: 'Нажмите, чтобы узнать больше',
};

export default ru;
